// extracted by mini-css-extract-plugin
export default {"navigationBarBackground":"ScrollingAppWrapper_navigationBarBackground__A56tE","white":"ScrollingAppWrapper_white__c-Zy+"};